import request from '@/utils/request'


// 查询用户认证列表
export function listAuthentication(query) {
  return request({
    url: '/user/user-authentication/list',
    method: 'get',
    params: query
  })
}

// 查询用户认证分页
export function pageAuthentication(query) {
  return request({
    url: '/user/user-authentication/page',
    method: 'get',
    params: query
  })
}

// 查询用户认证数量
export function queryAuthenticationCount(query) {
  return request({
    url: '/user/user-authentication/queryAuthenticationCount',
    method: 'get',
    params: query
  })
}

// 查询用户认证详细
export function getAuthentication(data) {
  return request({
    url: '/user/user-authentication/detail',
    method: 'get',
    params: data
  })
}

// 新增用户认证
export function addAuthentication(data) {
  return request({
    url: '/user/user-authentication/add',
    method: 'post',
    data: data
  })
}

// 修改用户认证
export function updateAuthentication(data) {
  return request({
    url: '/user/user-authentication/edit',
    method: 'post',
    data: data
  })
}

// 删除用户认证
export function delAuthentication(data) {
  return request({
    url: '/user/user-authentication/delete',
    method: 'post',
    data: data
  })
}
